import { render, staticRenderFns } from "./ShoppingMenu.vue?vue&type=template&id=d5a919ba"
import script from "./ShoppingMenu.vue?vue&type=script&lang=js"
export * from "./ShoppingMenu.vue?vue&type=script&lang=js"
import style0 from "./ShoppingMenu.vue?vue&type=style&index=0&id=d5a919ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports